/** Active login tab panel: Google button, errors, and sign-in/up forms. */
import AuthProviderButton from '@/features/auth/AuthProviderButton';
import LoginSignInForm from '@/features/auth/LoginSignInForm';
import LoginSignUpForm from '@/features/auth/LoginSignUpForm';
import LoginForgotPasswordForm from '@/features/auth/LoginForgotPasswordForm';
/**
 * @param {Object} props
 * @param {ReturnType<typeof import('@/features/auth/useLoginEmailAuth').useLoginEmailAuth>} props.auth
 * @param {boolean} props.signInSelected
 * @param {string} props.googleLabel
 * @param {() => void} props.onGoogleSignIn
 * @param {string | null} props.googleErrorKey
 * @param {(key: string, fallback: string) => string} props.t
 */
export function LoginEmailAuthPanelBody({
  auth,
  signInSelected,
  googleLabel,
  onGoogleSignIn,
  googleErrorKey,
  t,
}) {
  return (
    <>
      <AuthProviderButton label={googleLabel} onClick={onGoogleSignIn} />
      {googleErrorKey ? (
        <p
          className="login-server-error"
          role="alert"
          data-testid="login-google-error"
        >
          {t(googleErrorKey, googleErrorKey)}
        </p>
      ) : null}
      <p className="login-divider">
        <span>{t('login.or', 'or')}</span>
      </p>
      {auth.serverErrorKey ? (
        <p className="login-server-error" role="alert">
          {t(auth.serverErrorKey, auth.serverErrorKey)}
        </p>
      ) : null}
      {signInSelected && auth.forgotPasswordOpen ? (
        <LoginForgotPasswordForm
          email={auth.email}
          setEmail={auth.setEmail}
          onBackToSignIn={auth.closeForgotPassword}
        />
      ) : signInSelected ? (
        <LoginSignInForm
          email={auth.email}
          password={auth.password}
          fieldErrors={auth.fieldErrors}
          showPassword={auth.showPassword}
          loading={auth.loading}
          onEmailChange={(event) => auth.setEmail(event.target.value)}
          onPasswordChange={(event) => auth.setPassword(event.target.value)}
          onEmailBlur={() => auth.validateSignInBlur('email')}
          onPasswordBlur={() => auth.validateSignInBlur('password')}
          onToggleShowPassword={() => auth.setShowPassword((value) => !value)}
          onSubmit={auth.handleSignInSubmit}
          onForgotPassword={auth.openForgotPassword}
        />
      ) : (
        <LoginSignUpForm
          email={auth.email}
          password={auth.password}
          passwordConfirm={auth.passwordConfirm}
          fieldErrors={auth.fieldErrors}
          showPassword={auth.showPassword}
          showConfirmPassword={auth.showConfirmPassword}
          loading={auth.loading}
          onEmailChange={(event) => auth.setEmail(event.target.value)}
          onPasswordChange={(event) => auth.setPassword(event.target.value)}
          onPasswordConfirmChange={(event) =>
            auth.setPasswordConfirm(event.target.value)
          }
          onEmailBlur={() => auth.validateSignUpBlur('email')}
          onPasswordBlur={() => auth.validateSignUpBlur('password')}
          onPasswordConfirmBlur={() => auth.validateSignUpBlur('passwordConfirm')}
          onToggleShowPassword={() => auth.setShowPassword((value) => !value)}
          onToggleShowConfirmPassword={() =>
            auth.setShowConfirmPassword((value) => !value)
          }
          onSubmit={auth.handleSignUpSubmit}
        />
      )}
    </>
  );
}
